import { render, staticRenderFns } from "./ReviewsRequests.vue?vue&type=template&id=1347a185&scoped=true"
import script from "./ReviewsRequests.vue?vue&type=script&lang=js"
export * from "./ReviewsRequests.vue?vue&type=script&lang=js"
import style0 from "./ReviewsRequests.vue?vue&type=style&index=0&id=1347a185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347a185",
  null
  
)

export default component.exports